import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  accessToken: null, // Only store access token in Redux
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    updateTokens: (state, action) => {
      state.accessToken = action.payload.accessToken;
    },
    logout: (state) => {
      state.accessToken = null;
    },
  },
})

export const { updateTokens, logout } = authSlice.actions;
export default authSlice.reducer;
